import { LocaleEnum } from '@systemeio/ui-frontend'
import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch'
import { blogItems } from '../constants/blog-items'
import { MenuItemsInterface, bottomMenuItems } from '../constants/bottom-menu-items'

export const Menu = () => {
  const router = useRouter()
  const locale = router.locale as LocaleEnum

  return (
    <>
      <BottomMenuItem item={bottomMenuItems[0]} locale={locale} />
      <BottomMenuItem
        item={{
          sectionTitle: 'public.public_footer.resources.title',
          items: blogItems[locale].length > 0 ? blogItems[locale] : blogItems[LocaleEnum.ENGLISH],
        }}
        locale={locale}
      />
      {bottomMenuItems.slice(1).map((item, idx) => (
        <BottomMenuItem key={idx} item={item} locale={locale} />
      ))}
    </>
  )
}

const BottomMenuItem = ({ item, locale }: { item: MenuItemsInterface; locale: LocaleEnum }) => {
  const { t } = useTranslation()
  return (
    <div className={'flex flex-col gap-4'}>
      <span className={'font-bold text-brand-primary'}>{t(item.sectionTitle)}</span>
      {item.items.length !== 0 && (
        <div className={'flex flex-col gap-4'}>
          {item.items
            .filter(subItem => !subItem.excludeLocales?.includes(locale))
            .map((subItem, subIdx) => (
              <LinkWithoutPrefetch
                locale={subItem.noLoco ? false : locale}
                key={subIdx}
                className={
                  'main-transition-colors w-fit outline-none hover:text-brand-primary focus-visible:text-brand-primary'
                }
                href={subItem.allLoco ? '/' + locale + subItem.href : subItem.href}
              >
                {subItem.title.startsWith('public.public_footer')
                  ? t(subItem.title)
                  : subItem.title}
              </LinkWithoutPrefetch>
            ))}
        </div>
      )}
    </div>
  )
}
